import styled from 'styled-components';

const HEADER = '57px';
const PADDING_MODAL = '190px';
const TITLE_MODAL = '27px';
const TITLE_MARGIN_MODAL = '33px';
const BUTTON_BACK = '19px';
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - ${TITLE_MODAL} - ${TITLE_MARGIN_MODAL});

  .MuiAccordion-root {
    width: 100%;
  }

  > .MuiAccordion-root
    > .MuiCollapse-root
    > .MuiCollapse-wrapper
    > .MuiCollapse-wrapperInner
    > div
    > .MuiAccordionDetails-root {
      max-height: calc(
        100vh - ${HEADER} - ${PADDING_MODAL} - ${TITLE_MODAL} -
          ${TITLE_MARGIN_MODAL} - ${BUTTON_BACK}
      );
    }
`;